import { ProtectedRouteIndex } from '@/routes/config';
import { lazyImport } from '@/utils/lazyImport';
import { Navigate, Route, Routes } from 'react-router-dom';

const { ProjectsIndex } = lazyImport(() => import('../components/ProjectsIndex'), 'ProjectsIndex');
const { ProjectsNew } = lazyImport(() => import('../components/ProjectsNew'), 'ProjectsNew');
const { ProjectsLayout } = lazyImport(() => import('../components/ProjectsLayout'), 'ProjectsLayout');
const { ProjectsEdit } = lazyImport(() => import('../components/ProjectsEdit'), 'ProjectsEdit');
const { ProjectAreaAccountCredentials } = lazyImport(
  () => import('../components/ProjectAreaAccountCredentials'),
  'ProjectAreaAccountCredentials',
);
const { ProjectAreaUsersManagement } = lazyImport(
  () => import('../components/ProjectAreaUsersManagement'),
  'ProjectAreaUsersManagement',
);

const { ProjectAreaServiceAccounts } = lazyImport(
  () => import('../components/ProjectAreaServiceAccounts'),
  'ProjectAreaServiceAccounts',
);

export const ProjectsRoutes = () => {
  return (
    <Routes>
      <Route path={ProjectRoutePaths.index} element={<ProjectsLayout />}>
        <Route index element={<ProjectsIndex />} />

        <Route path={`:${ProjectRoutePaths.project}/${ProjectRoutePaths.edit}`} element={<ProjectsEdit />}>
          <Route index element={<Navigate to={ProjectRoutePaths.accountCredentials} />} />
          <Route path={ProjectRoutePaths.accountCredentials} element={<ProjectAreaAccountCredentials />} />
          <Route path={ProjectRoutePaths.userManagement} element={<ProjectAreaUsersManagement />} />
          <Route path={ProjectRoutePaths.serviceAccounts} element={<ProjectAreaServiceAccounts />} />
        </Route>
      </Route>
      <Route path={ProjectRoutePaths.new} element={<ProjectsNew />} />
    </Routes>
  );
};

export const projectPathResolvers = {
  projects: () => `/${ProtectedRouteIndex}/${ProjectRoutePaths.index}`,
  projectNew: () => `/${ProtectedRouteIndex}/${ProjectRoutePaths.new}`,
  projectEdit: (params: { projectName: string }) =>
    `${projectPathResolvers.projects()}/${params.projectName}/${ProjectRoutePaths.edit}`,
  projectAccountCredentials: (params: { projectName: string }) =>
    `${projectPathResolvers.projects()}/${params.projectName}/${ProjectRoutePaths.edit}/${
      ProjectRoutePaths.accountCredentials
    }`,
  projectUserManagement: (params: { projectName: string }) =>
    `${projectPathResolvers.projects()}/${params.projectName}/${ProjectRoutePaths.edit}/${
      ProjectRoutePaths.userManagement
    }`,
  projectServiceAccounts: (params: { projectName: string }) =>
    `${projectPathResolvers.projects()}/${params.projectName}/${ProjectRoutePaths.edit}/${
      ProjectRoutePaths.serviceAccounts
    }`,
};

const ProjectRoutePaths = {
  index: 'projects' as const,
  new: 'project-new' as const,
  edit: 'edit' as const,
  accountCredentials: 'account-credentials' as const,
  userManagement: 'user-management' as const,
  serviceAccounts: 'service-accounts' as const,
  project: 'projectName' as const,
};
